import PageHeader from "@/components/site/PageHeader";
import { Giving } from "@/components/site/Sections";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function GivePage() {
  usePageMeta(
    "Give — Partner With The Vision",
    "Give securely to RE//FORM PLACE CHI, a 501(‌c)(3) nonprofit in Chicago, via Cash App, Zelle, or PayPal. Your generosity fuels outreach, discipleship, and leadership development.",
  );
  return (
    <div data-testid="give-page">
      <PageHeader
        crumb="Give"
        eyebrow="Giving"
        title="Partner With"
        accent="The Vision"
        intro="RE//FORM PLACE CHI is a recognized 501(‌c)(3) organization. Your gift fuels worship, youth development, outreach, and leadership programs across Chicago."
        image="/outreach/serving-together.webp"
        imagePosition="center 30%"
      />
      <Giving />
      <CTABand
        eyebrow="See Where It Goes"
        title="Your Gift In Action"
        text="1,582 kids fed. 800+ boxes delivered. 9,720 meals packed in 2025 — see the full outreach story."
        primary={{ to: "/outreach", label: "View Our Impact" }}
        secondary={{ to: "/contact", label: "Ask A Question" }}
      />
    </div>
  );
}
